import { format } from 'date-fns';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useTranslation } from '../../hooks/useTranslation';
import styles from './styles.module.styl';

function CommunityAuthor({ org, repo }) {
  const { t } = useTranslation('core');
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    if (org && repo) {
      fetch(`https://api.github.com/repos/${org}/${repo}`)
        .then((r) => r.json())
        .then(({ updated_at: updatedAt }) => setLastUpdated(updatedAt));
    }
  }, [org, repo]);

  return (
    <div className={styles.anonymousCommunityAuthor}>
      <div className={styles.communityInfo}>
        {org && repo ? (
          <a
            href={`https://github.com/${org}/${repo}/contributors`}
            className={styles.communityText}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('quickstarts.platformInformation.CommunityAuthor.communityMaintained', 'Community maintained')}
            <i className="icon-budicon-522" />
          </a>
        ) : (
          <span className={styles.communityText}>
            {t('quickstarts.platformInformation.CommunityAuthor.communityMaintained', 'Community maintained')}
          </span>
        )}
        <div className={styles.lastUpdated}>
          {lastUpdated &&
            `${t('quickstarts.platformInformation.CommunityAuthor.lastUpdated', 'Last Updated')} ${format(
              lastUpdated,
              'MM/DD/YYYY'
            )}`}
        </div>
      </div>
    </div>
  );
}

CommunityAuthor.propTypes = {
  org: PropTypes.string.isRequired,
  repo: PropTypes.string.isRequired,
};

export default CommunityAuthor;
